class StylesUtils {
  static getMarginClasses(mt, mr, mb, ml) {
    let res = "";
    if (mt > 0) res = "mt-" + mt;
    if (mr > 0) res += " mr-" + mr;
    if (mb > 0) res += " mb-" + mb;
    if (ml > 0) res += " ml-" + ml;
    return res;
  }
}

export { StylesUtils as default };
